var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrone2 = function SvgDrone2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.006 19q0-1.644.91-2.93a4.72 4.72 0 0 1 2.361-1.787l-.423-3.667H4.987V6H2.025V5h6.923v1H5.987v3.616h1.738l-.103-1h8.75l-.104 1h1.719V6h-2.962V5h6.948v1h-2.961v4.616h-2.848l-.423 3.667q1.452.501 2.358 1.787t.907 2.93h-1q0-1.65-1.117-2.825T14.14 15H9.852q-1.611 0-2.729 1.175Q6.006 17.35 6.006 19zm4.24-5h5.495l.502-4.384H8.725z"
  })));
};
export default SvgDrone2;